// Note: Per convo with Hector Ramos, we need to provide userInfo to Abba to prevent user targeting from breaking.
// The following was extraced from lineup main/src/~components/AbbaProviderWithUserInfo/index.tsx

import React, { useState, useEffect, ReactNode } from "react";
import Cookies from "js-cookie";
import get from "lodash.get";
import { COLLECTIVE_USER_DATA_COOKIE } from "reg-ui-client/dist/lib/constants";
import { AbbaProvider, AbbaUserInfo } from "@foundation/abba-client";
import { useRegUIClient } from "@foundation/reg-ui-client";

interface AbbaProviderWithUserInfoProps {
    children: ReactNode;
}

/* TODO Temporary until lightsaber is on ^4.0.0 of reg-ui-client and ^2.0.0 of foundation/reg-ui-client and any peer dependency conflicts are resolved.
    Once that is done we can fetch directly from client.getSubscriberData() */
export const getDaysSubscribed = (): number | undefined => {
    const userDataCookie = Cookies.get(COLLECTIVE_USER_DATA_COOKIE);
    if (userDataCookie) {
        const userData = JSON.parse(userDataCookie);
        return get(userData, "subscriberData.daysSubscribed");
    }
    return undefined;
};

export const AbbaProviderWithUserInfo = ({
    children,
}: AbbaProviderWithUserInfoProps) => {
    const { client, session } = useRegUIClient();
    const [userInfo, setUserInfo] = useState<AbbaUserInfo>({});

    useEffect(() => {
        const subscriber =
            client?.isBWSubscriber() ||
            client?.isBBGSubscriber() ||
            client?.isTerminalSubscriber();

        if (subscriber === userInfo?.subscriber) {
            return;
        }

        setUserInfo({ subscriber, daysSubscribed: getDaysSubscribed() });
    }, [client, session, userInfo?.subscriber]);

    return (
        <AbbaProvider platform="article" user={userInfo}>
            {children}
        </AbbaProvider>
    );
};
